import * as React from "react";
import { Box } from "~/design-system/Box";
import type { Filters } from "../../../../../UserNotificationsScreen";
import { NotificationsFilterContent } from "./components/NotificationsFilterContent";

type NotificationsFilterProps = {
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  filters: Filters;
};

const NotificationsFilter = (props: NotificationsFilterProps) => {
  return (
    <Box
      borderRadius="standard"
      boxShadow="small"
      padding="gutter"
      css={{ border: "1px solid $neutral100" }}
      marginBottom="gutter"
      position="sticky"
      top={0}
    >
      <NotificationsFilterContent
        filters={props.filters}
        setFilters={props.setFilters}
      />
    </Box>
  );
};

export { NotificationsFilter };
